import store from '@/store'
import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'

const hasAccessToPage = (
    to: RouteLocationNormalized,
    _from: RouteLocationNormalized,
    next: NavigationGuardNext
): void => {
    store.dispatch('auth/oidcCheckAccess', to).then((hasAccess) => {
        if (hasAccess) {
            store.dispatch('ui/setMenuState', 'closed')
            next()
        }
    })
}

export default hasAccessToPage
